<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; chatset=UTF-8" http-equiv="Content-Type"/>
<title>#19 Mallory and MaryAnn Take New York S13 R1</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="image" id="fm00-fig-001"><img alt="" src="images/title.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?77cfcb40